// For Development

// export const API_URL = "https://dev.jobdashflash.com/api/admin";
// export const FILE_UPLOAD_API_URL = "https://dev.jobdashflash.com";


export const API_URL = "https://dev.jobbeavergo.com/api/admin";
export const FILE_UPLOAD_API_URL = "https://dev.jobbeavergo.com";

// For Production
// export const API_URL = "http://app.locksmithhub.net/api/admin";
// export const FILE_UPLOAD_API_URL = "http://app.locksmithhub.net";

export const GOOGLE_MAP_API_KEY = "AIzaSyANFvytlUdoF9WVD7zmQm5N9UhTF2FSjjc";
